import type { BetbyEnvironmentConfig } from '@app/core/environment-service';

/**
 * Betby PRODUCTION stack (delivered by the integration manager, 2026-07-22). Wired into the
 * production profiles (prod, store-prod) and — by host — into the csgofast4/local flavors of the
 * stage bundle (betby-stack.util.ts): the stage bundle serves several stand domains of one worker,
 * and the `*.devfast.io` stands run the dev backend whose Betby integration is the BETA stack.
 * NB: authorized play on a stand works only when the stand's backend signs the player token against
 * this same production stack.
 *
 * The delivery also included two backend-side endpoints the frontend never calls (listed here so
 * nobody goes looking for a missing env var): the external Betby API (gw9yca5f.sptenv.com) is what
 * OUR backend talks to, and the operator API (back-new.csgofast.com — the floating back-new.{host}
 * gateway) is what Betby calls back into. The frontend only fetches the player token from its own
 * `/api/bet/token` through the regular GATEWAY_URL.
 *
 * `playerAuthEnabled: true` requires our ES256 public key to be registered on the PRODUCTION Betby
 * environment (it was registered on beta); until Betby confirms it, a logged-in player gets a
 * `handshake_fail` and an empty widget while guests are unaffected — verify on the first production
 * smoke test.
 *
 * (Betby PRODUCTION OPERATOR id for support requests — not a widget option — is 2691628937552990216.)
 */
export const BETBY_PROD_CONFIG: BetbyEnvironmentConfig = {
  scriptUrl: 'https://csgofast.sptpub.com/bt-renderer.min.js',
  brandId: '2691628937552990217',
  // The brand theme confirmed on the Betby side for csgofast (same name as on beta).
  themeName: 'csgofast',
  playerAuthEnabled: true,
};
